import { render, staticRenderFns } from "./bannerCom.vue?vue&type=template&id=54fef608&scoped=true&"
import script from "./bannerCom.vue?vue&type=script&lang=ts&"
export * from "./bannerCom.vue?vue&type=script&lang=ts&"
import style0 from "./bannerCom.vue?vue&type=style&index=0&id=54fef608&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fef608",
  null
  
)

export default component.exports